import "./assets/styles.scss";
import "./assets/helper.css";
import { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
// import { FaTachometerAlt, FaAppStore, FaRegUser, FaUserCheck, FaWindowRestore, FaFileCode, FaBuffer } from "react-icons/fa";
import RenderRoutes from "./components/Routes/renderRoutes";
import HeaderResponsiveComponent from "./components/common/HeaderResponsiveComponent";
import FooterComponent from "./components/common/FooterComponent";
import ScrollToTop from "./ScrollToTop";
import PageTracker from "./components/common/PageTracker";
import ImagePopUp from "./components/common/ImagePopUp";

function App() {
  // State to track if the app has finished loading
  const [isLoaded, setLoaded] = useState(false);

  // Get current location (for SSR safety)
  const location =
    typeof window !== "undefined" && window.location
      ? { pathname: window.location.pathname }
      : { pathname: "/" };

  // Effect to handle initial loading and show spinner
  useEffect(() => {
    // Show the app after a short delay (simulate loading)
    const timer = setTimeout(() => {
      const appContainer = document.getElementById("appContainer");
      if (appContainer) appContainer.style.display = "block";
      setLoaded(true);
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  // Effect to handle scroll event for sticky header
  useEffect(() => {
    // Handler for scroll event
    const handleScroll = () => {
      const nav = document.querySelector("nav");
      const anchor = document.querySelector("a");
      const header = document.querySelector("header");
      if (!nav || !anchor || !header) return;
      // Get header height (fallback to 0 if not set)
      const headerHeight = parseInt(header.style.height) || 0;
      const top = window.scrollY;
      const windowWidth = window.innerWidth;
      // Toggle fixed-header-desktop class based on scroll position and width
      if (top > headerHeight && windowWidth > 1024) {
        nav.classList.add("fixed-header-desktop");
        anchor.classList.add("fixed-header-desktop");
      } else {
        nav.classList.remove("fixed-header-desktop");
        anchor.classList.remove("fixed-header-desktop");
      }
    };
    // Add scroll event listener
    window.addEventListener("scroll", handleScroll, false);
    // Clean up on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll, false);
    };
  }, []);

  // Scroll to top handler for the button
  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  return (
    <>
      <div className="App">
        {/* Loading spinner overlay while app is loading */}
        {!isLoaded && (
          <div
            style={{
              backgroundColor: "rgba(31, 32, 41, 0.75)",
              transition: "opacity 250ms 700ms ease",
            }}
            className="w-[100%] h-screen flex justify-center items-center z-[30] backdrop-blur fixed overflow-y-hidden "
          >
            <svg
              aria-hidden="true"
              className="inline w-[7%] h-[7%] mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-red-500"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        )}
        {/* Only show ImagePopUp on root page after loading */}
        {isLoaded && location.pathname === "/" && <ImagePopUp />}
        <div id="appContainer" className="app_container">
          <BrowserRouter>
            <ScrollToTop />
            <PageTracker />
            <HeaderResponsiveComponent />
            {/* MAIN COMPONENT RENDERING */}
            <div
              id="main-content-app"
              className="outlet_wraper content-tcs lg:pt-[0rem] md:pt-[4.7rem]  sm:pt-[4.7rem] pt-[4.2rem]"
            >
              {/* Main route rendering area */}
              <RenderRoutes />
            </div>
            {/* Scroll to top button */}
            <div className="flex justify-end mr-[2rem] ">
              <button
                onClick={scrollToTop}
                className="bg-[#f21e26] text-white w-[30px] h-[30px] rounded-full icon-position"
                aria-label="Scroll to top"
              >
                <i className="fa-solid fa-arrow-up"></i>
              </button>
            </div>
            {/* Footer section */}
            <div className="">
              <FooterComponent />
            </div>
          </BrowserRouter>
        </div>
      </div>
    </>
  );
}

export default App;
